module.exports = __webpack_public_path__ + "media/1.98b2b02a.wav";